import React from "react";
import { Link } from "react-router-dom";
import { CALENDLY_URL, PHONE_DISPLAY, WHATSAPP_DISPLAY } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="max-w-[1320px] mx-auto px-5 lg:px-10 mt-24" data-testid="final-cta">
      <div className="aidify-card-dark p-8 md:p-14 relative overflow-hidden" data-reveal>
        {/* Decorative animated blobs */}
        <div className="pointer-events-none absolute -top-10 -right-10 w-48 h-48 rounded-full bg-sage-500/15 blur-2xl float-y-slow" aria-hidden="true" />
        <div className="pointer-events-none absolute -bottom-12 left-1/2 w-40 h-40 rounded-full bg-sage-200/10 blur-3xl float-y" aria-hidden="true" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative">
          <div className="lg:col-span-8">
            <div className="mb-5">
              <span className="section-pill !bg-forest-500 !text-cream-100/80 !border-forest-400">
                <span className="opacity-70">→</span> Ready to begin?
              </span>
            </div>
            <h3 className="font-display text-4xl md:text-6xl font-extrabold leading-[1.05] tracking-tight">
              Your first step takes
              <br />
              <span className="font-serif-italic font-normal text-sage-200">less than 30 minutes.</span>
            </h3>
            <p className="mt-6 text-cream-100/70 max-w-xl">
              The conversation is free. The match is fast. And your US partner is already waiting.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href={CALENDLY_URL} target="_blank" rel="noreferrer" className="btn-on-dark group" data-testid="cta-book-call">
                Book a Discovery Call <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a href="tel:+16465951666" className="text-cream-100/70 text-sm hover:text-cream-100 transition-colors link-underline">
                or call <span>{WHATSAPP_DISPLAY}</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-4 flex justify-end">
            <div className="aidify-card-sage p-6 max-w-[260px] w-full relative">
              <div className="relative w-24 h-24 mb-4">
                <span className="absolute inset-0 rounded-full bg-forest-600/15 spin-slow" />
                <div className="relative w-24 h-24 rounded-full overflow-hidden ring-2 ring-forest-600/15">
                  <img
                    src="/teamImages/supriya-image.png"
                    alt="Sweety L."
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="absolute -bottom-0.5 right-0.5 w-4 h-4 rounded-full bg-sage-500 border-2 border-cream-100" />
              </div>
              <div className="font-display font-bold text-forest-600 text-lg">Sweety L.</div>
              <div className="text-xs uppercase tracking-[0.18em] text-forest-500/70 mt-1">Business Head</div>
              <Link to="/contact" className="text-xs mt-4 inline-flex items-center gap-1 text-forest-600 link-underline">Talk to Sweety <ArrowRight size={12} /></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
